<template>
    <div class="row member-card">
        <div class="memberSearch-wrap">
            <form @submit.prevent="setFilters">
                <div class="form-group row">
                    <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                        <label>System Id</label>
                        <input v-model="filters.policy_id" type="text" class="memberSearch-field"
                            placeholder="Enter System Id" />
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                        <label>Member Name</label>
                        <input v-model="filters.member_name" type="text" class="memberSearch-field"
                            placeholder="Enter Member Name" />
                    </div>
                     <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                        <label>Rep Name</label>
                        <input v-model="filters.agent_name" type="text" class="memberSearch-field"
                            placeholder="Enter Rep Name" />
                    </div>
                   <!-- <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                        <label>Plan Name</label>
                        <input v-model="filters.plan_name" type="text" class="memberSearch-field"
                            placeholder="Enter Plan Name" />
                    </div> -->
                     <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                        <label>Status</label>
                        <select class="info-field" v-model="filters.term_status">
                            <option value="">Select Status</option>
                            <option value="A">APPROVED</option>
                            <option value="R">REJECTED</option>
                            <option value="P">PENDING</option>
                        </select>
                    </div>
                </div>

                <div class="row justify-content-md-end">
                    <div class="col-xxl-2 col-xl-3">
                        <button type="submit" class="univ-btn">Search</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

export default {
    name: "TermRequestSearch",
    props: {
        filters: {
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
        clear: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        setFilters() {
            this.$emit("onSearch", this.filters);
        }
    },
    watch: {
        clear() {
            if (this.clear) {
                this.$emit("onClearSearch");
            }
        }
    }
};
</script>
<style scoped>
.effective_date .mx-datepicker {
    width: 100% !important;
}

.form-select:focus {
    border-color: #03C3EC;
}

.info-field{
    width: 100%;
    border: 1px solid #dce1e7;
    outline: none;
    border-radius: 6px;
    padding: 9px 15px;
    font-size: 14px;
    transition: all ease 0.6s;
}
</style>